export default __webpack_public_path__ + "static/media/black_circle.fab8ec29.svg";